import { Box, Container, SpeedDial, SpeedDialAction, SpeedDialIcon } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import React, { useContext, useState } from 'react';
import CloseIcon from 'remixicon-react/CloseFillIcon';
import ChatIcon from 'remixicon-react/QuestionAnswerFillIcon';
import HelpIcon from 'remixicon-react/QuestionnaireFillIcon';
import SearchIcon from 'remixicon-react/Search2FillIcon';
import { useTheme } from '../theme';
import { AppContext } from './AppContext';
import ChatFrame from './ChatFrame';
import { useIframe } from './FrameUtils';

const actions = [
  { icon: <ChatIcon />, name: 'Chat' },
  { icon: <SearchIcon />, name: 'Search' }
];
function App() {
  const { state, dispatch } = useContext(AppContext);
  const [showSpeedDial, setShowSpeedDial] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);
  const { theme } = useTheme();
  let sendFrameMessage = useIframe(dispatch);

  const toggleChat = () => {
    setShowSpeedDial(false);
    setShowPrompt(false);
    dispatch({ type: "setShowChat", showChat: !state.showChat })
    dispatch({ type: 'setHasOpened', hasOpened: true })
  }
  const navigateWidget = (path: string) => {
    sendFrameMessage({ isEdulla: true, action: "navigate", data: path })
    toggleChat();
  }

  const toggleShowPrompt = () => {
    if (!showPrompt && !state.showChat && !state.enteredInformation && !state.hasOpened) {
      setShowPrompt(true);
    }
  }

  if (!showPrompt && !state.showChat && !state.enteredInformation && !state.hasOpened) {
    setTimeout(toggleShowPrompt, 5000);
  }
  if (theme) {
    return (
      <ThemeProvider theme={theme}>
        <React.StrictMode>
          <Container
            sx={{ padding: '0px !important', position: 'fixed', bottom: 25, right: 25, width: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end', gap: '0px', maxHeight: '95vh', height: (!state.showChat ? 'auto' : '95vh'), background: 'none !important', zIndex: 9999 }}>
            <ChatFrame></ChatFrame>
            <Box sx={{
              fontFamily: "sans-serif",
              position: 'absolute',
              right: '0px',
              width: 'auto',
              bottom: '69px',
              padding: (showPrompt ? '10px 20px' : '0px'),
              background: "#e8e8e8",
              borderRadius: "6px",
              maxHeight: '90px',
              maxWidth: !showPrompt ? "0px" : "224px",
              overflow: 'hidden',
              opacity: !showPrompt ? "0" : "1",
              transition: 'all .5s',
              minWidth: '200px',
              fontSize: '16px',
              boxShadow: "0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)"
            }}>Hello! Is there anything I can help you with today?</Box>
            <SpeedDial
              ariaLabel="Chat and Search"
              icon={<SpeedDialIcon sx={{ svg: { width: '24px', height: '24px' } }} icon={(state.showChat ? <CloseIcon size={24} /> : <HelpIcon size={24} />)} openIcon={<CloseIcon size={24} />} />}
              onClick={() => toggleChat()}
              open={!state.showChat && showSpeedDial && state.enteredInformation}
              onMouseEnter={() => setShowSpeedDial(true)}
              onMouseLeave={() => setShowSpeedDial(false)}
              hidden={!state.isLandscape && state.showChat}
            >
              {!state.showChat && showSpeedDial && state.enteredInformation && actions.map((action) => (
                <SpeedDialAction
                  key={action.name}
                  icon={action.icon}
                  tooltipTitle={action.name}
                  onClick={(e) => { e.stopPropagation(); navigateWidget(`/${action.name}`); }}
                />
              ))}
            </SpeedDial></Container>
        </React.StrictMode>
      </ThemeProvider >
    );
  }
  else {
    return (<h1>Loaded</h1>)
  }
}

export default App;

